<style >
.l-br {
    font-size: 0;
    display: block;
  }

</style>
<template>
    
    <div class="col backgroundForm">
        
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#nav-ordop-active" role="tab" aria-controls="nav-new-user" aria-selected="true"><font-awesome-icon icon="th-list" /> Operaciones Activas</a>
                <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-ordop-finish" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="th-list" /> Listado de Operaciones Finalizadas</a>
            </div>
        </nav>
        
     <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="nav-ordop-active" role="tabpanel" aria-labelledby="nav-new-user-tab">
            <br><br>
            <div class="col col-md-6 offset-md-3">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading" align="center">Cuadro de Orden de Operaciones Activas</h4>                       
                </div>            
            </div>
            
            <div class="btn-group col-12 col-md-6 offset-md-3" role="group" aria-label="Grupo ejemplo">
                <button class=" btn btn-warning" @click="mCallOrdopsVigent()"> <font-awesome-icon icon="sync-alt" size="lg" :spin="animate_button" /> Actualizar</button>
                <button class="  btn btn-info" @click="mCopyToClipboard(table_ordops_id)" :disabled="table_results!=='' && table_results!==null ? false:true"> <font-awesome-icon icon="copy" size="lg" /> Copiar</button>
                <button class="  btn btn-success" @click="mExportToExcel()" :disabled="table_results!=='' && table_results!==null ? false:true"> <font-awesome-icon icon="file-excel" size="lg" /> Exportar</button>
                <button class="  btn btn-info" @click="mGetVigentesPrint()" :disabled="table_results!=='' && table_results!==null ? false:true"> <font-awesome-icon icon="print" size="lg" /> Imprimir</button>
            </div>
            
            <br><br>
                    
            <div id="tabla_vigentes">
                <div class="table-responsive" :id="table_ordops_id">
                    <table class="table table-responsive table-bordered table-hover"  ref="table" v-html="table_results">
                        
                    </table>
                </div>
            </div>
            
        </div>
        <!-- END TAB 1 -->
        
        <div class="tab-pane fade show" id="nav-ordop-finish" role="tabpanel" aria-labelledby="nav-new-user-tab">
            <br><br>
            <div class="col col-md-10 offset-md-2">
                <div class="alert alert-info" role="info">
                    <h4 class="alert-heading" align="center">Cuadro de Orden de Operaciones Finalizadas</h4>                       
                </div>            
            </div>
            
            <div class="form-row">
                <div class="form-group col-12 col-md-4 offset-md-4">
                    <label for="time_init_ordop">Gestion </label>
                    <select name="year_r" id="year_r" class="form-control" v-model="year_select">
                        <option v-for="y in years" :value="y.c" :key="y.c" :selected="y.c==year_select">{{ y.c }}</option>
                    </select>
                </div>
            </div>
            
            <div class="btn-group col-12 col-md-6 offset-md-3" role="group" aria-label="Grupo ejemplo">
                <button class=" btn btn-warning" @click="mCallOrdopsFinish()"> <font-awesome-icon icon="sync-alt" size="lg" :spin="animate_button_finish" /> Actualizar</button>
                <button class="  btn btn-info" @click="mCopyToClipboard(table_ordops_finish)" :disabled="table_results_finish!=='' && table_results_finish!==null ? false:true"> <font-awesome-icon icon="copy" size="lg" /> Copiar</button>
                <button class="  btn btn-success" @click="mExportToExcelFinish()" :disabled="table_results_finish!=='' && table_results_finish!==null ? false:true"> <font-awesome-icon icon="file-excel" size="lg" /> Exportar</button>
                <button class="  btn btn-info" @click="mGetFinalesPrint()" :disabled="table_results_finish!=='' && table_results_finish!==null ? false:true"> <font-awesome-icon icon="print" size="lg" /> Imprimir</button>
            </div>
            
            <br><br>
            <div class="table-responsive" :id="table_ordops_finish">
                <table class="table table-responsive table-bordered table-hover" ref="table" v-html="table_results_finish">
                    
                </table>
            </div>
            
            
        </div>
        <!-- end tab 2 -->
        
    </div>

    <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>
</template>

<script>

import modalReport from '../modal/modalReport';

import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';


export default {
    data(){
        return{
            table_ordops_id:'ordops_table',
            table_ordops_finish:'ordops_table_finish',
            updateTable:null,
            dtsTable:[],
            initOrdop:[],
            resultOrdop:[],
            id_modal_progress:'idTableResume',
            title_modal:'Cargando',
            send_dispatch:true,
            year_option_resume:[],
            year_select_resume:0,
            table_results:null,
            table_results_finish:null,
            dtsCaptain:[],
            ordops_vigente:[],
            ordops_finalizada:[],
            url_report:'',
            animate_button:false,
            animate_button_finish:false,
            year_select:0,
            years:[]
        }
    },
    mounted(){
        // this.callTypesOrdop();
        this.getYears();
        this.mCallOrdopsVigent();
        window.vueInstance = this;
    },
    beforeDestroy(){
        delete window.vueInstance;
        this.destroyUpdate();
    },
    methods:{
        mGetVigentesPrint() {
            const printContent = document.getElementById('tabla_vigentes').innerHTML;
            const originalContent = document.body.innerHTML;
            
            document.body.innerHTML = `
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css">
                ${printContent}
            `;
            
            window.print();
            document.body.innerHTML = originalContent; 
        },
        mGetFinalesPrint() {
            const printContent = document.getElementById(this.table_ordops_finish).innerHTML;
            const originalContent = document.body.innerHTML;
            
            document.body.innerHTML = `
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css">
                ${printContent}
            `;
            
            window.print();
            document.body.innerHTML = originalContent; 
        },
        getYears(){
            console.log('llamando a los años');
            let ya=new Date();
            this.year_select=ya.getFullYear();
            const init=2018;
            this.years=[];
            for(let i=init; i<=this.year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
            // this.dts_millas.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
        },
        mExportToExcel() {
            console.log('solicitando excel');
            this.url_report=btoa('generateActiveOrdops');
                // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
            let route = this.$router.resolve({path: `/report/${this.url_report}`});            
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
        },
        mExportToExcelFinish() {
            console.log('solicitando excel');
            this.url_report=btoa(`generateFinishOrdops/${this.year_select}`);
                // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                // let url_report=btoa(`pdfOrdopI/${id}`)
            let route = this.$router.resolve({path: `/report/${this.url_report}`});            
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
        },
        
        mCopyToClipboard(elemento) {

            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada con exito', 'Archivo copiado')
        },
        async callTypesOrdop(){
            
            // this.activeModal(this.id_modal_progress);
            
            let ordopsVigent=await axios.get(`getOrdopActives?api_token=${Vue.auth.getToken()}`);
            // console.log(ordopsVigent);
            
            let or=await axios.get(`globals/ordop?api_token=${Vue.auth.getToken()}`);
            let oi=await axios.get(`globals/ordopinit?api_token=${Vue.auth.getToken()}`);

                // console.log(od);
            this.initOrdop=oi.data;
            this.resultOrdop=or.data;
            // console.log(this.initOrdop);
            // console.log(this.resultOrdop);
            
            setTimeout(()=>{
                // this.inactiveModal(this.id_modal_progress);
                this.animate_button=false;
                this.mArmTable();
            },2000)
            
        },
        async mCallOrdopsVigent(){
            this.animate_button=true;
            this.table_results='';
            let ordopsVigent=await axios.get(`getOrdopActives?api_token=${Vue.auth.getToken()}`);
            if(ordopsVigent.data.length>0){
                this.ordops_vigente=ordopsVigent.data;
                setTimeout(()=>{
                // this.inactiveModal(this.id_modal_progress);
                    this.animate_button=false;
                    this.mArmTable();
                },2000)
            }else{
                toastr.warning(`No se han encontrado Ordops Vigentes`);
                setTimeout(()=>{
                    this.animate_button=false;
                }, 2000)
            }            
        },
        async mCallOrdopsFinish(){
            this.animate_button_finish=true;
            this.table_results_finish='';
            let ordopsFinish=await axios.get(`getOrdopFinish/${this.year_select}?api_token=${Vue.auth.getToken()}`);
            if(ordopsFinish.data.length>0){
                this.ordops_finalizada=ordopsFinish.data;
                setTimeout(()=>{
                // this.inactiveModal(this.id_modal_progress);
                    this.animate_button_finish=false;
                    this.mArmTableFinish();
                },2000)
            }else{
                toastr.warning(`No se han encontrado Ordops Vigentes`);
            }            
        },
        async callCaptains(){            
            if(this.year_select_resume>0){
                this.destroyUpdate();
                try {
                    console.log('llamamos una vez al cuadro');
                        // let dtsCaptain=await axios.get();
                        let dtsOrdops=await axios.get(`getAllOrdops/${this.year_select_resume}?api_token=${Vue.auth.getToken()}`);
                        
                        this.dtsCaptain=dtsOrdops.data;
                        
                        this.armTable();
                        this.updateTable=setInterval(async ()=>{
                            try {
                                console.log('actualizamos el cuadro');
                                let dtsOrdops=await axios.get(`getAllOrdops/${this.year_select_resume}?api_token=${Vue.auth.getToken()}`);
                                
                                this.dtsCaptain=dtsOrdops.data;
                                
                                this.armTable();
                            } catch (error) {
                                console.log(error)
                            }
                        }, 900000) 
                } catch (error) {
                    console.log(error)
                }
            }else{
                toastr.warning('Seleccione una Gestion', 'Error');
            }      
        },
        mRandomColor(){
            let randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
            let r = randomBetween(0, 255);
            let g = randomBetween(0, 255);
            let b = randomBetween(0, 255);
            let old_color = `rgb(${r},${g},${b}, 0.2 )`; 
            return old_color;
        },
        mArmTable(){
            let table_aux=`<thead>
                <tr class="bg-dark text-light">
                    <th class="align-middle text-center" style="font-size: 12px;">N°</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Gran Unidad</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Unidad Dependiente</th>
                    <th class="align-middle text-center" style="font-size: 12px;">ORDOP \n FH: Inicio</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Misión</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Donde</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Logistica Empleada</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Efectivo Personal</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Resultados</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Estado</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Reportes</th>
                </tr>
                </thead>
                <tbody>`;
            // console.log(`aqui llegando a las ORDOP vigente`);
            // console.log(this.ordops_vigente);
            let importe_total=0;
            this.ordops_vigente.forEach((dts, index)=>{
                table_aux+=`<tr>
                        <td class="align-middle" style="font-size: 12px;">${index+1}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.gran_unidad}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.unidad_dependiente}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.titulo_ordop}&nbsp;<span class="l-br"></span>FI:${dts.fecha_inicio}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.tarea}</td>`;
                
                        let cord=dts.coordenadas;
                        // console.log(dts.coordenadas);
                if(cord.length>0){
                    let coords='';
                    cord.forEach(dtc=>{
                        coords+=`<b>${dtc.descripcion}</b><span class="l-br"></span>${dtc.latitud},${dtc.longitud}<span class="l-br"></span>\r\n`;
                    })
                    table_aux+=`<td class="" style="font-size: 12px;">${coords}</td>`
                }else{
                    table_aux+=`<td style="font-size: 12px;">No Registra</td>`;
                }
                
                table_aux+=`<td class="align-middle" style="font-size: 12px;">${dts.medios}</td>`;
                
                let participantes='';
                if(dts.superiores>0){
                    participantes+=`- ${dts.superiores} OO.SUP.`;
                }
                if(dts.subalternos>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.subalternos} OO.SUB.`;
                }
                if(dts.suboficiales>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.suboficiales} SOF(S).`;
                }
                if(dts.sargentos>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.sargentos} SGTO(S).`;
                }
                if(dts.marinos>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.marinos} MAR(S).`;
                }
                table_aux+=`<td class="align-middle" style="font-size: 12px;">${participantes}</td>`;
                
                let results=dts.resultados;
                
                if(results.length>0){
                    let resordops='';
                    results.forEach(dtc=>{
                        resordops+=`<b>${dtc.tipo_resultado}</b>\r\n Incautado Bs. ${parseFloat(dtc.importe_incautacion).toLocaleString("es-ES")} Aprox. Operación<span class="l-br"></span>\r\n <hr>`;
                        importe_total+=parseFloat(dtc.importe_incautacion);
                    })
                    table_aux+=`<td class="" style="font-size: 12px;">${resordops}</td>`
                }else{
                    table_aux+=`<td class="align-middle" style="font-size: 12px;">Sin resultados</td>`;
                }
                
                table_aux+=`<td class="align-middle" style="font-size: 12px;">En Ejecución</td>`;
                table_aux+=`<td><button class="btn btn-success" onclick="window.vueInstance.mReportI(${dts.id_ordop})">S</button><button class="btn btn-info" onclick="window.vueInstance.mVerDocumento(${dts.id_ordop})">D</button></td></tr>`;
                
            })
            table_aux+=`<tr><td colspan="3"><b>Total Importe Bs. Incautado:</b></td><td colspan="8"><b>${importe_total.toLocaleString("es-ES")}</b></td></tr>`;
            table_aux+=`</tbody>`;
            
            this.table_results=table_aux;
        },
        mArmTableFinish(){
            let table_aux=`<thead>
                <tr class="bg-dark text-light">
                    <th class="align-middle text-center" style="font-size: 12px;">N°</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Gran Unidad</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Unidad Dependiente</th>
                    <th class="align-middle text-center" style="font-size: 12px;">ORDOP \n FH: Inicio \n FH: Conclusión</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Misión</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Donde</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Logistica Empleada</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Efectivo Personal</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Resultados</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Estado</th>
                    <th class="align-middle text-center" style="font-size: 12px;">Reportes</th>
                </tr>
                </thead>
                <tbody>`;
            // console.log(`aqui llegando a las ORDOP vigente`);
            // console.log(this.ordops_vigente);
            let importe_total_finish=0;
            this.ordops_finalizada.forEach((dts, index)=>{
                table_aux+=`<tr>
                        <td class="align-middle" style="font-size: 12px;">${index+1}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.gran_unidad}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.unidad_dependiente}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.titulo_ordop}&nbsp;<span class="l-br"></span>FI:${dts.fecha_inicio}<span class="l-br"></span>FF:${dts.fecha_conclusion}</td>
                        <td class="align-middle" style="font-size: 12px;">${dts.tarea}</td>`;
                
                let cord=dts.coordenadas;
                        // console.log(dts.coordenadas);
                if(cord.length>0){
                    let coords='';
                    cord.forEach(dtc=>{
                        coords+=`<b>${dtc.descripcion}</b><span class="l-br"></span>${dtc.latitud},${dtc.longitud}<span class="l-br"></span>\r\n`;
                    })
                    table_aux+=`<td class="" style="font-size: 12px;">${coords}</td>`
                }else{
                    table_aux+=`<td style="font-size: 12px;">No Registra</td>`;
                }
                
                table_aux+=`<td class="align-middle" style="font-size: 12px;">${dts.medios}</td>`;
                
                let participantes='';
                if(dts.superiores>0){
                    participantes+=`- ${dts.superiores} OO.SUP.`;
                }
                if(dts.subalternos>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.subalternos} OO.SUB.`;
                }
                if(dts.suboficiales>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.suboficiales} SOF(S).`;
                }
                if(dts.sargentos>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.sargentos} SGTO(S).`;
                }
                if(dts.marinos>0){
                    participantes+=`<span class="l-br"></span>\r\n- ${dts.marinos} MAR(S).`;
                }
                table_aux+=`<td class="align-middle" style="font-size: 12px;">${participantes}</td>`;
                
                let results=dts.resultados;
                
                if(results.length>0){
                    let resordops='';
                    results.forEach(dtc=>{
                        resordops+=`<b>${dtc.tipo_resultado}</b>\r\n Incautado Bs. ${parseFloat(dtc.importe_incautacion.toLocaleString("es-ES"))} Aprox. Operación<span class="l-br"></span>\r\n <hr>`;
                        importe_total_finish+=parseFloat(dtc.importe_incautacion);
                    })
                    table_aux+=`<td style="font-size: 12px;">${resordops}</td>`
                }else{
                    table_aux+=`<td class="align-middle" style="font-size: 12px;">Sin resultados</td>`;
                }
                table_aux+=`<td class="align-middle" style="font-size: 12px;">Finalizado</td>`;
                table_aux+=`<td><button class="btn btn-success" onclick="window.vueInstance.mReportI(${dts.id_ordop})">S</button><button class="btn btn-info" onclick="window.vueInstance.mVerDocumento(${dts.id_ordop})">D</button></td>`;
                
            })
            table_aux+=`<tr><td colspan="3"><b>Total Importe Bs. Incautado:</b></td><td colspan="8"><b>${importe_total_finish.toLocaleString("es-ES")}</b></td></tr>`;
            table_aux+=`</tbody>`;
            
            this.table_results_finish=table_aux;
        },
        mReportI(id){
            // console.log(`el id es ${id}`);
            // this.title_modal='Descargando';
            
            // let route = this.$router.resolve({path: `pdfOrdopI/${id}?api_token=${Vue.auth.getToken()}`});
            let url_report=btoa(`pdfOrdopI/${id}`)
            let route = this.$router.resolve({path: `/report/${url_report}`});
            // let route = this.$router.resolve('/link/to/page'); // This also works.
            // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');  
        },
        async mVerDocumento(idTask){
                console.log('viendo el documento adjunto de la ORDOP')
                let url_report=btoa(`pdfDocument/${idTask}`)
                let route = this.$router.resolve({path: `/report/${url_report}`});
                // let route = this.$router.resolve('/link/to/page'); // This also works.
                // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
        },
        armTable(){
            let cio=this.initOrdop.length;
            let cro=this.resultOrdop.length;
            
            let captain_color=this.mRandomColor();
            let ordop_i_color=this.mRandomColor();
            let ordop_res_color=this.mRandomColor();
            let ordop_tot_init_col=this.mRandomColor();
            let ordop_tot_res_col=this.mRandomColor();

            let tableAux=`<thead class="fijo" style="position:sticky; top:0; z-index:10;     background-color: white;"><tr>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${captain_color}">#</th>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${captain_color}">CAPITANIA</th>
                            <th scope="col" colspan="${cio}" align="center" class="text-center" style="background-color:${ordop_i_color}">ORDOP Inicial</th>
                            <th scope="col" colspan="${cro}" align="center" class="text-center" style="background-color:${ordop_res_color}">Resultados ORDOP</th>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${ordop_tot_init_col}"># APERTURADAS</th>
                            <th scope="col" rowspan="2" class="align-middle text-center" style="background-color:${ordop_tot_res_col}"># RESULTADOS</th>
                          </tr>
                          <tr>`;
            this.initOrdop.forEach(oi => {
                tableAux+=`<th scope="col" class="text-center" style="background-color:${ordop_i_color}; position:sticky; top:0; z-index:10;">${oi.detail}</th>`
            });
            this.resultOrdop.forEach(ro => {
                tableAux+=`<th scope="col" class="text-center" style="background-color:${ordop_res_color}; position:sticky; top:0; z-index:10; ">${ro.detail}</th>`
            });
            tableAux+=`</thead><tbody>`
            // recorremos las capitanias

            let sumTotalIni=0;
            let sumTotalRes=0;
            this.dtsCaptain.forEach((captain, index)=>{
                tableAux+=`<tr><th scope="row" class="align-middle text-center">${index+1}</th><td class="text-center fijo2" style="position:sticky; left:0; top: 0; z-index:9;     background-color:white;">${captain.capitania}</td>`;
                let resinit=captain.init;
                let resend=captain.results;

                let sumIni=0;
                let sumRes=0;               

                this.initOrdop.forEach((oi, index) => {
                    // oi.id         
                    let quantityInit=0;
                    if(resinit.length > 0){
                        resinit.forEach((oic)=>{
                            if(oi.id===oic.id){
                                quantityInit=oic.cantidad;
                                
                            }
                        })
                        if(quantityInit>0){
                            tableAux+=`<td class="align-middle text-center">${quantityInit}</td>`;
                            sumIni+=parseInt(quantityInit);
                            sumTotalIni+=parseInt(quantityInit);
                        }else{
                            tableAux+=`<td class="align-middle text-center">----</td>`;
                        }
                        
                    }else{
                        tableAux+=`<td class="align-middle text-center">----</td>`;
                    }

                });

                this.resultOrdop.forEach((roe, index) => {
                    // roe.id                  
                    let quantityResult=0;
                    if(resend.length > 0){
                        resend.forEach((orc)=>{
                            if(roe.id === orc.id){
                                quantityResult=orc.cantidad;   
                            }
                        })
                        if(quantityResult>0){
                            tableAux+=`<td class="align-middle text-center">${quantityResult}</td>`;
                            sumRes+=parseInt(quantityResult);
                            sumTotalRes+=parseInt(quantityResult);
                        }else{
                            tableAux+=`<td class="align-middle text-center">----</td>`;
                        }
                    }else{
                        tableAux+=`<td class="align-middle text-center">----</td>`;
                    }
                });

                tableAux+=`<td class="align-middle text-center">${sumIni}</td>`;
                tableAux+=`<td class="align-middle text-center">${sumRes}</td>`;
                tableAux+=`</tr>`;    
            });
            let colsTotal=2+cio+cro;
            tableAux+=`<tr><th colspan="${colsTotal}" scope="row" class="align-middle text-center">TOTAL</th><td class="align-middle text-center">${sumTotalIni}</td><td class="align-middle text-center">${sumTotalRes}</td></tr></tbody>`;
            this.table_results=tableAux;
        },
        destroyUpdate(){
            console.log('destruyendo el evento');
            clearInterval(this.updateTable);
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-report':modalReport
    },
}
</script>

<style scoped>
@media print {
  @page {
    size: A4 landscape; /* Orientación horizontal */
    margin: 0; /* Opcional: reduce márgenes */
  }

  body, html {
    width: 100%;
    height: 100%;
  }

  /* Asegúrate de que la tabla ocupe el ancho máximo */
  table {
    width: 100% !important;
    border-collapse: collapse;
  }

  /* Evita saltos de página no deseados */
  tr {
    page-break-inside: avoid;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopActiveResume.vue